import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_LAST_UPDATED, LEGAL_PRIVACY_EMAIL, LEGAL_SITE_URL } from "./legalContent";
import "./LegalPages.css";

export default function LegalPageShell({ title, children }) {
  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <div className="legal-page__header-inner">
          <Link to="/" className="legal-page__back" aria-label="Back to home">
            <ArrowLeft size={18} strokeWidth={2.25} />
            <span>Back to home</span>
          </Link>
          <Link to="/" className="legal-page__brand">
            Beentara
          </Link>
        </div>
      </header>

      <main className="legal-page__main">
        <article className="legal-page__article">
          <h1 className="legal-page__title">{title}</h1>
          <p className="legal-page__meta">
            Last updated: {LEGAL_LAST_UPDATED} ·{" "}
            <a href={LEGAL_SITE_URL} target="_blank" rel="noopener noreferrer">
              beentara.com
            </a>
          </p>
          <div className="legal-page__body">{children}</div>
        </article>
      </main>

      <footer className="legal-page__footer">
        <p>
          Questions about privacy?{" "}
          <a href={`mailto:${LEGAL_PRIVACY_EMAIL}`}>{LEGAL_PRIVACY_EMAIL}</a>
        </p>
        <nav className="legal-page__footer-nav" aria-label="Legal">
          <Link to="/privacy">Privacy Policy</Link>
          <span aria-hidden="true">·</span>
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          <span aria-hidden="true">·</span>
          <Link to="/refund-policy">Refund Policy</Link>
          <span aria-hidden="true">·</span>
          <Link to="/contact">Contact Us</Link>
        </nav>
      </footer>
    </div>
  );
}
